<template>
  <div
    class="bg-background-neutral-secondary flex flex-col items-center space-y-4 rounded-2xl p-4"
  >
    <img
      src="../../assets/images/medical-insurance-error-icon.svg"
      width="64"
      height="64"
      alt=""
      role="presentation"
    />
    <div class="space-y-1 text-center">
      <p class="text-text-neutral-primary font-semibold">
        {{ t('productsErrorCard.title') }}
      </p>
      <p class="text-text-neutral-quaternary text-sm">
        {{ t('productsErrorCard.contentText') }}
      </p>
    </div>
    <FreeButton size="sm" class="gray-button w-full" @click="$emit('onRetry')">
      {{ t('productsErrorCard.retry') }}
    </FreeButton>
  </div>
</template>

<script setup lang="ts">
  import { useI18n } from 'vue-i18n';
  import { FreeButton } from '../../shared/ui';

  const { t } = useI18n();

  defineEmits<{
    onRetry: [];
  }>();
</script>

<i18n src="./locales.json"></i18n>
